module.exports = __webpack_public_path__ + "media/gifts/gift-bbl-face-treatment-fa9f8bd3.png";